import { Campaign } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomText,
  CustomHeaderText,
  FormLabels,
} from 'src/components'

const campaignsColumns: ColumnsType<Campaign> = [
  {
    title: () => <CustomHeaderText text='footPrint.Name' />,
    responsive: ['sm'],
    sorter: (a: Campaign, b: Campaign) => a.name.length - b.name.length,
    render: (_, campaign) => (
      <div style={{ marginBottom: '-15px' }}>
        <FormLabels
          title={campaign.name}
          subtitle={campaign.code}
        />
      </div>
    )
  },
  {
    title: () => <CustomHeaderText text='Vouchers.Owner' />,
    responsive: ['sm'],
    sorter: (a: Campaign, b: Campaign) => a.owner_user_email.length - b.owner_user_email.length,
    render: (_, campaign) => (
      <div className='mt-2'>
        <CustomText
          label={campaign.owner_user_email}
          style={{ color: 'blue' }}
        />
      </div>
    )
  },
  {
    title: () => <CustomHeaderText text='Vouchers.Count' isCentered />,
    responsive: ['sm'],
    sorter: (a: Campaign, b: Campaign) => a.discount_vouchers.length - b.discount_vouchers.length,
    render: (_, campaign) => (
      <CustomText
        label={campaign.discount_vouchers.length}
        className='centered mt-3'
        strong
      />
    )
  },

  // Mobile View
  {
    title: () => <CustomHeaderText text='Vouchers.Campaign' />,
    responsive: ['xs'],
    sorter: (a: Campaign, b: Campaign) => a.name.length - b.name.length,
    render: (_, campaign) => (
      <FormLabels
        title={`${campaign.name} (${campaign.discount_vouchers.length})`}
        subtitle={campaign.code}
        thirdLabel={campaign.owner_user_email}
      />
    )
  },
]

export default campaignsColumns
